/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Deck_Url_Import_Provider_DownInputs */



/**
* | output |
* | --- |
* | "{provider} did not answer. Try again in a moment, or switch to Paste, which always works." |
*
* @param {Deck_Url_Import_Provider_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_url_import_provider_down = /** @type {((inputs: Deck_Url_Import_Provider_DownInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Url_Import_Provider_DownInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.provider} n'a pas répondu. Réessayez dans un instant, ou passez à Coller un Deck, qui fonctionne toujours.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.provider} no respondió. Inténtelo de nuevo en un momento o cambie a Pegar Deck, que siempre funciona.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.provider} não respondeu. Tente novamente em instantes ou mude para Colar Deck, que sempre funciona.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.provider} non ha risposto. Riprova tra un momento, oppure passa a Incolla Deck, che funziona sempre.`)
	return /** @type {LocalizedString} */ (`${i?.provider} did not answer. Try again in a moment, or switch to Paste, which always works.`)
});